import {
  START_LOADING, END_LOADING,
  FETCH_CREDIT_DEBIT_NOTES,
  FETCH_CREDIT_DEBIT_NOTE,
  CREATE_CREDIT_DEBIT_NOTE,
  UPDATE_CREDIT_DEBIT_NOTE,
  DELETE_CREDIT_DEBIT_NOTE,
} from "../actions/constants";

const initialState = {
  isLoading: false,
  notes: [],
  currentNote: null,
  numberOfPages: 0,
  currentPage: 1,
  total: 0,
};

const creditDebitNotes = (state = initialState, action) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, isLoading: true };
    case END_LOADING:
      return { ...state, isLoading: false };

    case FETCH_CREDIT_DEBIT_NOTES:
      return {
        ...state,
        notes: action.payload.notes || [],
        numberOfPages: action.payload.numberOfPages || 1,
        currentPage: action.payload.currentPage || 1,
        total: action.payload.total || 0,
      };

    case FETCH_CREDIT_DEBIT_NOTE:
      return { ...state, currentNote: action.payload };

    case CREATE_CREDIT_DEBIT_NOTE:
      return { ...state, notes: [action.payload, ...state.notes] };

    case UPDATE_CREDIT_DEBIT_NOTE:
      return {
        ...state,
        notes: state.notes.map((n) =>
          n._id === action.payload._id ? action.payload : n
        ),
        currentNote:
          state.currentNote?._id === action.payload._id
            ? action.payload
            : state.currentNote,
      };

    case DELETE_CREDIT_DEBIT_NOTE:
      return {
        ...state,
        notes: state.notes.filter((n) => n._id !== action.payload),
        currentNote:
          state.currentNote?._id === action.payload ? null : state.currentNote,
      };

    default:
      return state;
  }
};

export default creditDebitNotes;
